import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import success from '../../Assets/images/success2.png';

function ValuationSuccessModal({ open, handleClose }) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: 400,
          bgcolor: 'background.paper',
          borderRadius: '24px',
          boxShadow: 24,
          p: 4,
          outline: 'none',
          textAlign: 'center'
        }}>

          <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6">
            <img src={success} alt="success" className="w-20 h-20" />
          </div>

          <h2 className="text-[#1E222B] text-[20px] font-bold mb-3">Valuation Request Submitted</h2>
          <p className="text-[#808285] text-[14px] leading-relaxed mb-8 px-2">
            Your valuation request has been submitted. We'll notify you once the updated valuation is ready and your position is listed on the Secondary Market.
          </p>

          <button
            onClick={handleClose}
            className="w-full py-3 bg-[#00BC67] text-white rounded-lg font-[600] text-[15px]"
          >
            Continue
          </button>
        </Box>
      </Fade>
    </Modal>
  );
}

export default ValuationSuccessModal;
